import * as Feed from '@constants/feed';

import {RootAction, LootsheetLockDuck, GuildDuck} from '@ducks';

import {LootsheetLock} from '@models/lootsheetLock';

const initialState: LootsheetLockDuck.State = {
	byId: {}
};

export default function reducer(
	state = initialState,
	action: RootAction
): LootsheetLockDuck.State {
	switch (action.type) {
		case LootsheetLockDuck.LOCK:
		case LootsheetLockDuck.UNLOCK:
			return state;

		case GuildDuck.FETCH_DATA_SUCCESS: {
			const byId: LootsheetLockDuck.State['byId'] = {};
			action.payload.lootsheetLocks.forEach((x) => (byId[x.id] = x));

			return {
				...state,

				byId
			};
		}

		// feed
		case Feed.LOOTSHEET_LOCK_INSERT:
		case Feed.LOOTSHEET_LOCK_UPDATE: {
			return {
				...state,

				byId: {
					...state.byId,
					[action.payload.newRecord.id]: new LootsheetLock(action.payload.newRecord)
				}
			};
		}

		case Feed.LOOTSHEET_LOCK_DELETE: {
			const {[action.payload.oldRecord.id]: deleted, ...rest} = state.byId;

			return {
				...state,
				byId: rest
			};
		}

		default:
			return state;
	}
}
